/**
 * Cross-page sync via window CustomEvent + BroadcastChannel (per tab-switching)
 * Emits and listens for changes to customer services (minute packages included)
 * so that scadenzario cliente + assistenze cliente stay in sync in real-time.
 */

const EVENT_NAME = "services:changed";
const CHANNEL_NAME = "officina-services-sync";

let channel = null;
function getChannel() {
  if (channel) return channel;
  if (typeof window !== "undefined" && "BroadcastChannel" in window) {
    try { channel = new BroadcastChannel(CHANNEL_NAME); } catch { channel = null; }
  }
  return channel;
}

/** Broadcast that a customer's services have changed (minute logs, renewals, edits, deletes). */
export function emitServicesChanged(customerId) {
  const payload = { customerId, ts: Date.now() };
  try { window.dispatchEvent(new CustomEvent(EVENT_NAME, { detail: payload })); } catch {}
  const ch = getChannel();
  if (ch) { try { ch.postMessage(payload); } catch {} }
}

/**
 * Subscribe to services changes for a given customer.
 * @param {string|null} customerId - Only react to events for this customer (or all if null)
 * @param {Function} handler - Called with the payload when a change happens
 * @returns cleanup function
 */
export function onServicesChanged(customerId, handler) {
  const wrapped = (ev) => {
    const data = ev.detail || ev.data;
    if (!data) return;
    if (customerId && data.customerId && data.customerId !== customerId) return;
    handler(data);
  };
  window.addEventListener(EVENT_NAME, wrapped);
  const ch = getChannel();
  if (ch) ch.addEventListener("message", wrapped);
  return () => {
    window.removeEventListener(EVENT_NAME, wrapped);
    if (ch) ch.removeEventListener("message", wrapped);
  };
}
